import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaFacebook, FaEnvelope } from 'react-icons/fa';
import '../../App.css'; // Make sure your CSS file that includes the font import is linked

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  // Close the menu when clicking outside of it
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Close the menu when the route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const NavButton = ({ to, children }) => {
    return (
      <Link
        to={to}
        className="block font-semibold px-4 py-2 rounded hover:bg-gray-600 transition-colors duration-300"
      >
        {children}
      </Link>
    );
  };

  const ExternalButton = ({ href, icon, children }) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="font-semibold px-4 py-2 rounded hover:bg-gray-600 transition-colors duration-300 flex items-center space-x-2"
      >
        {icon}
        <span className="hidden md:inline">{children}</span>
      </a>
    );
  };

  const HamburgerButton = ({ isOpen, onClick }) => {
    return (
      <button onClick={onClick} className="focus:outline-none">
        <div className="relative w-6 h-6">
          <div
            className={`absolute w-full h-0.5 bg-white transform transition duration-300 ease-in-out ${
              isOpen ? 'rotate-45 translate-y-2' : ''
            }`}
          ></div>
          <div
            className={`absolute w-full mt-2 h-0.5 bg-white transform transition duration-300 ease-in-out ${
              isOpen ? 'opacity-0' : ''
            }`}
          ></div>
          <div
            className={`absolute w-full mt-4 h-0.5 bg-white transform transition duration-300 ease-in-out ${
              isOpen ? '-rotate-45 -translate-y-2' : ''
            }`}
          ></div>
        </div>
      </button>
    );
  };

  const NavButtons = () => {
    return (
      <div className="flex flex-col md:flex-row lg:space-x-4 ">
        {/* <NavButton to="/">Home</NavButton> */}
        {/* <NavButton to="/registration">Register</NavButton> */}
        <NavButton to="/winners">2026 Winners</NavButton>
        {/* <NavButton to="/checkout">Checkout</NavButton> */}
        <NavButton to="/judge">Login</NavButton>
        

        <div className='h-px my-4 bg-gray-400 w-full md:hidden shadow-sm'/>
        <div className='flex text-3xl md:text-base mx-auto'>
            <ExternalButton href="https://www.facebook.com/pages/Basehor-Car-Show/146270654902?fref=ts" icon={<FaFacebook />}></ExternalButton>
            <ExternalButton href="mailto:basehorcarshow@gmail.com" icon={<FaEnvelope />}></ExternalButton>
        </div>
      </div>
    );
  };

  return (
    <header className="bg-gray-800 text-white p-5 " ref={menuRef}>
      <div className="container mx-auto flex justify-between items-center">
        <Link to='/' className="text-3xl font-basehor">Basehor <span className="font-autumn font-normal flex">Car Show</span></Link>
        <nav className="hidden md:flex">
          <NavButtons />
        </nav>
        <div className="md:hidden">
          <HamburgerButton isOpen={isOpen} onClick={toggleMenu} />
        </div>
      </div>
      <div
        className={`absolute top-28 left-0 right-0 bg-gray-700 z-50 overflow-hidden transition-all duration-500 ease-in-out ${
          isOpen ? 'max-h-screen' : 'max-h-0'
        }`}
      >
        <nav className="flex flex-col p-4 space-y-2">
          <NavButtons />
        </nav>
      </div>
    </header>
  );
};

export default Header;
